import React, { useState } from "react";
import { Modal, Button, Text, Group } from "@mantine/core";
import modalContentData from "../../data/modalContentData";

const InformationModal = () => {
  const [opened, setOpened] = useState(false);
  const [modalContent, setModalContent] = useState<any>(null);
  const [modalTitle, setModalTitle] = useState('About');
  const [activeButton, setActiveButton] = useState<string | null>(null);

  const openModal = (content: any, buttonType: any) => {
    setModalContent(content);
    setActiveButton(buttonType);
    switch (buttonType) {
      case 'about':
        setModalTitle('About');
        break;
      case 'needHelp':
        setModalTitle('Need Help?');
        break;
      case 'contact':
        setModalTitle('Contact Us');
        break;
      default:
        setModalTitle('About');
    }

    setOpened(true);
  };

  const closeModal = () => {
    setOpened(false);
    setActiveButton(null); 
  };

  return (
    <div className="information-modal">
      {/* Group for Buttons */}
      <Group style={{ marginBottom: "0.7rem", marginTop: "0.7rem" }}>
        <Button
          style={{
            width: "7.5rem",
            height: "2.5rem",
            color: "white",
            backgroundColor:
              activeButton === "about" ? "#d3d3d3" : "#4a525e",
          }}
          onClick={() => openModal(modalContentData.about, "about")}
        >
          About
        </Button>
        <Button
          style={{
            width: "7.5rem",
            height: "2.5rem",
            color: "white",
            backgroundColor:
              activeButton === "needHelp" ? "#d3d3d3" : "#4a525e",
          }}
          onClick={() => openModal(modalContentData.needHelp, "needHelp")}
        >
          Need Help?
        </Button>
        <Button
          style={{
            width: "7.5rem",
            height: "2.5rem",
            color: "white",
            backgroundColor:
            activeButton === "contact" ? "#d3d3d3" : "#4a525e",
          }}
          onClick={() => openModal(modalContentData.contact, "contact")}
        >
          Contact Us
        </Button>
      </Group>


      <Modal
        opened={opened}
        onClose={closeModal}
        title={modalTitle}
        size="xl"
        overlayProps={{
          color: "rgba(216, 235, 227, 0.6)",
          opacity: 2,
          blur: 3,
        }}
        centered
        styles={{
          content: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          },
          body: {
            overflowY: 'auto',
            flex: 1, // Makes the body take up the available space
            paddingBottom: 0, // Remove padding so that footer aligns with the bottom
          },
        }}
      >
        <Text size="md" style={{ flex: 1, overflowY: 'auto', paddingBottom: 100 }}>{modalContent}</Text>

        <Group
          style={{
            position: "absolute",
            bottom: 20,
            right: 20,
            left: 20,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
        <Button
          style={{
            width: "7.5rem",
            color: "white",
            backgroundColor:
              activeButton === "about" ? "#d3d3d3" : "#4a525e",
          }}
          onClick={() => openModal(modalContentData.about, "about")}
        >
          About
        </Button>
        <Button
          style={{
            width: "7.5rem",
            color: "white",
            backgroundColor:
              activeButton === "needHelp" ? "#d3d3d3" : "#4a525e",
          }}
          onClick={() => openModal(modalContentData.needHelp, "needHelp")}
        >
          Need Help?
        </Button>
        <Button
          style={{
            width: "7.5rem",
            color: "white",
            backgroundColor:
            activeButton === "contact" ? "#d3d3d3" : "#4a525e",
          }}
          onClick={() => openModal(modalContentData.contact, "contact")}
        >
          Contact Us
        </Button>
        </Group>
      </Modal>
    </div>
  );
};

export default InformationModal;
